var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDental(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 8.36124C25.75 2.24498 3.25 -3.38751 3.25 23.0387C3.25 43.6337 7.705 59.6237 14.5188 68.5675C16.9375 71.7437 22.8287 70.7575 25.3487 67.5737C25.6277 67.1994 25.8478 66.7846 26.0013 66.3437L29.9875 55.8437C32.44 49.3937 41.56 49.3937 44.0125 55.8437L47.9987 66.3437C48.1675 66.7787 48.3625 67.2062 48.6513 67.5737C51.1713 70.7612 57.0625 71.7437 59.4813 68.5675C66.295 59.6237 70.75 43.6375 70.75 23.0387C70.75 -3.38376 48.25 2.24498 37 8.36124ZM37 8.36124L48.25 14.5",
    stroke: "#585864",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDental);
export default __webpack_public_path__ + "static/media/dental.4c57be5a8f6564effd14d9f8263faa91.svg";
export { ForwardRef as ReactComponent };